import AddIcon from '@mui/icons-material/Add'
import DeleteIcon from '@mui/icons-material/Delete'
import {
    Box,
    Button,
    IconButton,
    List,
    ListItemButton,
    ListItemSecondaryAction,
    ListItemText,
    Typography,
} from '@mui/material'
import { ElementEditor } from './ElementEditor'
import { useElementDefinitions } from './useElementDefinitions'

export const ElementDefinitionsTab = (): JSX.Element => {
    const {
        elements,
        selectedIndex,
        selectedElement,
        dirty,
        setSelectedIndex,
        updateElement,
        addElement,
        removeElement,
        save,
    } = useElementDefinitions()

    return (
        <Box display="flex" height="calc(100vh - 112px)" overflow="hidden">
            {/* Left panel - element list */}
            <Box
                sx={{
                    width: 280,
                    minWidth: 280,
                    borderRight: '1px solid',
                    borderColor: 'divider',
                    display: 'flex',
                    flexDirection: 'column',
                    bgcolor: 'background.paper',
                }}
            >
                <Box
                    sx={{
                        p: 1.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="subtitle2">Elements ({elements.length})</Typography>
                    <Button size="small" startIcon={<AddIcon />} onClick={addElement}>
                        New
                    </Button>
                </Box>
                <List sx={{ overflow: 'auto', flex: 1, py: 0 }}>
                    {elements.map((el, i) => (
                        <ListItemButton
                            key={i}
                            selected={selectedIndex === i}
                            onClick={() => setSelectedIndex(i)}
                            sx={{ pr: 6 }}
                        >
                            <ListItemText
                                primary={el.name}
                                secondary={el.identifier}
                                primaryTypographyProps={{ noWrap: true, fontSize: '0.875rem' }}
                                secondaryTypographyProps={{ noWrap: true, fontSize: '0.75rem' }}
                            />
                            <ListItemSecondaryAction>
                                <IconButton
                                    edge="end"
                                    size="small"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        removeElement(i)
                                    }}
                                    color="error"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItemButton>
                    ))}
                </List>
            </Box>

            {/* Right panel - editor */}
            <Box sx={{ flex: 1, overflow: 'auto', position: 'relative' }}>
                {selectedElement ? (
                    <ElementEditor
                        element={selectedElement}
                        onChange={(updated) => updateElement(selectedIndex, updated)}
                    />
                ) : (
                    <Box display="flex" alignItems="center" justifyContent="center" height="100%">
                        <Typography color="text.secondary">Select an element</Typography>
                    </Box>
                )}

                {/* Fixed save button */}
                {dirty && (
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 24,
                            right: 24,
                            zIndex: 10,
                        }}
                    >
                        <Button variant="contained" size="large" onClick={save}>
                            Save
                        </Button>
                    </Box>
                )}
            </Box>
        </Box>
    )
}
